@if (text()) {
  <span [innerHTML]="text()"></span>
}
@if (contentTemplate()) {
  <ng-container *ngTemplateOutlet="contentTemplate()" />
}
